const Globals = {
    install(Vue) {
        Vue.mixin({
            methods: {
                $rest(url, data_object) {
                    const data = data_object || {};
                    let send_url = url;

                    if (send_url.startsWith('/') === false) {
                        send_url = `/${send_url}`;
                    }

                    if (window.location.host.startsWith('localhost')) {
                        send_url = `${window.location.protocol}//${window.location.hostname}:8000${send_url}`;
                    } else {
                        send_url = `https://app.checkout.software${send_url}`;
                    }

                    const body = {
                        method: data.method || 'POST',
                        body: data.body || {},
                        headers: data.headers || {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    };

                    if (!(body.body instanceof String)) {
                        body.body = JSON.stringify(body.body);
                    }

                    return fetch(send_url, body).then((response) => response.json());
                },
                $duration_string(total_months) {
                    const years = Math.floor(total_months / 12);
                    const months = total_months % 12;

                    let string = '';
                    if (years > 0) {
                        string += `${years} jaar`;
                    }

                    if (months > 0) {
                        if (string !== '') {
                            string += ' en ';
                        }
                        string += `${months} maanden`;
                    }

                    return string;
                },
                $Microbounce(timeout) {
                    const inner_timeout = timeout || 256;

                    let callback = null;
                    let last = null;
                    let inFlight = false;

                    return (cb) => {
                        callback = cb;
                        last = Date.now();

                        const next = () => {
                            const diff = Date.now() - last;
                            if (diff > inner_timeout) {
                                last = null;
                                inFlight = false;
                                callback();
                                callback = null;
                            } else {
                                window.setTimeout(next, diff);
                            }
                        };

                        if (!inFlight) {
                            inFlight = true;
                            window.setTimeout(next, inner_timeout);
                        }
                    };
                },
                $fix_zip_code(value) {
                    let zip_code = value;
                    zip_code = String(zip_code).toUpperCase();
                    return zip_code.replace(/[^0-9a-z]/gi, '');
                },
                $make_date_string(value) {
                    let inner_value = null;
                    if (value) {
                        try {
                            inner_value = new Date(value);
                        } catch (e) {
                            console.error(e);
                        }
                    }
                    inner_value = inner_value || new Date();

                    const year = String(inner_value.getFullYear());

                    let month = String(inner_value.getMonth() + 1);
                    if (month < 10 && String(month).length < 2) {
                        month = `0${String(month)}`;
                    }

                    let day = String(inner_value.getDate());
                    if (day < 10 && String(day).length < 2) {
                        day = `0${String(day)}`;
                    }

                    return `${year}-${month}-${day}`;
                },
            },
        });
    },
};

export default Globals;
